import { formatDate } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdminService } from 'src/app/core/services/admin.service';
import { LoginService } from 'src/app/core/login/login.service';
import { LearnerService } from 'src/app/core/services/learner.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import * as $ from 'jquery';
import { AppraisalService } from 'src/app/core/services/appraisal.service';
const defaultDialogConfig = new MatDialogConfig();
@Component({
    selector: 'promotion-history',
    templateUrl: './promotion-history.component.html',
    styleUrls: ['./promotion-history.component.scss']
})
export class PromotionHistoryComponent implements OnInit {

    promotionData: any;
    name: any;
    id: any;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<PromotionHistoryComponent>,
        private dialog: MatDialog,
        private fb: FormBuilder,
        private loginService: LoginService,
        private appraisalService: AppraisalService,
        private loaderService: LoaderService
    ) { }

    ngOnInit() {
        console.log("inside view session page", this.data);
        setTimeout(() => {
            this.loaderService.setLoading(false);
        }, 100);
        this.promotionData = this.data.data;
        this.name = this.data.name;
        this.id = this.data.emp_id;
    }

    cancel() {
        this.dialogRef.close();
    }

}